export default "__VITE_ASSET__CmyR8Kkk__"